var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":_vm.url,"width":_vm.width,"alt":_vm.title,"height":_vm.height},on:{"~error":function($event){return _vm.fallback.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }